import { FC, useEffect } from 'react';
import css from './accessories.module.scss';
import { accessoriesKey, accessoriesLink } from './const';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';

export const Accessories: FC<{ list: (keyof typeof accessoriesKey)[] }> = (props) => {
    const { isMobile, useLang, Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared.product');

    const accessoriesMap = {
        [accessoriesKey['wave2-add-on-battery']]: {
            webp: require('@publicLocal/product-common/accessories/wave-2-battery.webp'),
            img: require('@publicLocal/product-common/accessories/wave-2-battery.png'),
            name: t('accessories_add_on_battery'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['wave2-add-on-battery']][locale] || accessoriesLink[accessoriesKey['wave2-add-on-battery']].us,
        },
        [accessoriesKey['wave2-exhaust-ducts']]: {
            webp: require('@publicLocal/product-common/accessories/wave-2-ducts.webp'),
            img: require('@publicLocal/product-common/accessories/wave-2-ducts.png'),
            name: t('accessories_exhaust_ducts'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['wave2-exhaust-ducts']][locale] || accessoriesLink[accessoriesKey['wave2-exhaust-ducts']].us,
        },
        [accessoriesKey['wave2-bag']]: {
            webp: require('@publicLocal/product-common/accessories/wave-2-bag.webp'),
            img: require('@publicLocal/product-common/accessories/wave-2-bag.png'),
            name: t('accessories_bag'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['wave2-bag']][locale] || accessoriesLink[accessoriesKey['wave2-bag']].us,
        },
        [accessoriesKey['glacier-battery']]: {
            webp: require('@publicLocal/product-common/accessories/accessories_detail_1.webp'),
            img: require('@publicLocal/product-common/accessories/accessories_detail_1.png'),
            name: t('accessories_glacier_battery'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['glacier-battery']][locale] || accessoriesLink[accessoriesKey['glacier-battery']].us,
        },
        [accessoriesKey['glacier-wheels']]: {
            webp: require(`@publicLocal/product-common/accessories/accessories_detail_2${locale === 'au' ? '_au.png' : '.webp'}`),
            img: require(`@publicLocal/product-common/accessories/accessories_detail_2${locale === 'au' ? '_au' : ''}.png`),
            name: t('accessories_glacier_wheels'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['glacier-wheels']][locale] || accessoriesLink[accessoriesKey['glacier-wheels']].us,
        },
        [accessoriesKey['glacier-bag']]: {
            webp: require('@publicLocal/product-common/accessories/accessories_detail_3.webp'),
            img: require('@publicLocal/product-common/accessories/accessories_detail_3.png'),
            name: t('accessories_glacier_bag'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['glacier-bag']][locale] || accessoriesLink[accessoriesKey['glacier-bag']].us,
        },
        [accessoriesKey['blade-seb']]: {
            webp: require('@publicLocal/product-common/accessories/blade-seb.webp'),
            img: require('@publicLocal/product-common/accessories/blade-seb.png'),
            name: t('accessories_blade_seb'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['blade-seb']][locale] || accessoriesLink[accessoriesKey['blade-seb']].us,
        },
        [accessoriesKey['blade-lsk']]: {
            webp: require('@publicLocal/product-common/accessories/blade-lsk.webp'),
            img: require('@publicLocal/product-common/accessories/blade-lsk.png'),
            name: t('accessories_blade_lsk'),
            // @ts-ignore
            link: accessoriesLink[accessoriesKey['blade-lsk']][locale] || accessoriesLink[accessoriesKey['blade-lsk']].us,
        },
    } as const;

    useEffect(() => {
        setTimeout(() => {
            AniContainer.create({
                syncFromTo: [[`.${css.accessoriesComp}`, { opacity: 0 }, { opacity: 1 }]],
                triggerElement: `.${css.accessoriesComp}`,
                offset: '10%',
                duration: 100,
                triggerHook: 1,
            });
        }, 30);
    }, []);

    return (
        <div className={`${css.accessoriesComp} ${isMobile ? 'accessories-h5' : 'accessories-pc'}`}>
            <p className="accessories-title">{t('accessories_title')}</p>
            <div className="accessories-box">
                {props.list.map((key) => (
                    <div className="accessories-item" key={key}>
                        <div className="img-box">
                            <NextImage
                                webpSrc={accessoriesMap[key].webp}
                                src={accessoriesMap[key].img}
                                alt={accessoriesMap[key].name}
                                aria-label={accessoriesMap[key].name}
                            />
                        </div>
                        <div className="accessories-name">{accessoriesMap[key].name}</div>
                        <Link
                            className="accessories-link"
                            href={accessoriesMap[key].link}
                            ariaLabel={accessoriesMap[key].name}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_product',
                                list_name: 'Accessories',
                                product_name: accessoriesMap[key].name,
                                button_name: 'Learn more',
                            }}
                        >
                            {t('common_learn_more')}
                            <EFArrowRight />
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};
